var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3643_10619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2109 47.25V42.75C39.2109 40.3631 38.2627 38.0739 36.5749 36.386C34.8871 34.6982 32.5979 33.75 30.2109 33.75H12.2109C9.82399 33.75 7.5348 34.6982 5.84698 36.386C4.15915 38.0739 3.21094 40.3631 3.21094 42.75V47.25",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2109 24.75C26.1815 24.75 30.2109 20.7206 30.2109 15.75C30.2109 10.7794 26.1815 6.75 21.2109 6.75C16.2404 6.75 12.2109 10.7794 12.2109 15.75C12.2109 20.7206 16.2404 24.75 21.2109 24.75Z",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7109 47.2505V42.7505C52.7095 40.7564 52.0457 38.8192 50.824 37.2432C49.6023 35.6671 47.8917 34.5415 45.9609 34.043",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9609 7.04297C38.8969 7.53865 40.6128 8.66455 41.8381 10.2432C43.0635 11.8218 43.7286 13.7633 43.7286 15.7617C43.7286 17.7601 43.0635 19.7016 41.8381 21.2803C40.6128 22.8589 38.8969 23.9848 36.9609 24.4805",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3643_10619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0.960938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersicon);
export default __webpack_public_path__ + "static/media/usersicon.9789090eace7d1bafe584ae57494f8e9.svg";
export { ForwardRef as ReactComponent };